import { Hr } from '@euler/app/components/Hr';
import { useOrderSearchForm } from '@euler/app/flows/search/context';
import { Dropdown, DropdownOption } from '@euler/components/dropdown';
import { FormGroup } from '@euler/components/form';
import { ReceptionOrderStatus } from '@euler/model/enum';
import { memo, useCallback } from 'react';

const kOptions: DropdownOption<ReceptionOrderStatus>[] = [
  { value: ReceptionOrderStatus.Pending, label: '待进行' },
  { value: ReceptionOrderStatus.InProgress, label: '进行中' },
  { value: ReceptionOrderStatus.Finished, label: '已完成' },
  { value: ReceptionOrderStatus.Cancelled, label: '已取消' },
];

export const OrderStatusField = memo(() => {
  const { form } = useOrderSearchForm();

  const onChange = useCallback(
    (value: ReceptionOrderStatus | undefined) => {
      form.status.update(value);
    },
    [form.status],
  );

  return (
    <FormGroup label="订单状态">
      <Dropdown
        options={kOptions}
        value={form.status.value}
        placeholder="按订单状态搜索"
        clearable={true}
        onChange={onChange as any}
        ItemSeparatorComponent={() => <Hr color="#ddd" />}
      />
    </FormGroup>
  );
});
